import {Membership} from "./membership";
import {Season} from "./season";
import {AthleteSeason} from "./athleteSeason";

export class Athlete {

    id?: string;
    image?: string;
    firstName: string = '';
    lastName: string = '';
    bornDate: string = '';
    bornCity: string = '';
    fiscalCode: string = '';
    address?: string;
    city?: string;
    province?: string;
    phone?: string;
    alreadyPlayedInCompany?: number;
    previousCompanyName?: string;
    firstTimeAgonistic?: string;
    email?: string;
    status?: string | undefined;
    seasonStatus?: string | undefined;
    categoryId?: string;
    companyId? :string;
    company?: { id: string; name: string };
    userId: string = '';
    createdAt? : string;
    seasons: Season[] = [];
    memberships: Membership[] = [];
    note?: string;
    athleteSeasons: AthleteSeason[] = [];
    primaryDocExpirationDate?: string;
    citizenshipType?: string;



    constructor(raw?: Athlete) {

        if (raw) {
            this.id = raw.id;
            this.firstName = raw.firstName;
            this.lastName = raw.lastName;
            this.image = raw.image;
            this.bornDate = raw.bornDate;
            this.bornCity = raw.bornCity;
            this.fiscalCode = raw.fiscalCode;
            this.email = raw.email;
            this.address = raw.address;
            this.city = raw.city;
            this.province = raw.province;
            this.phone = raw.phone;
            this.companyId = raw.companyId;
            this.categoryId = raw.categoryId;
            this.userId = raw.userId;
            this.alreadyPlayedInCompany = raw.alreadyPlayedInCompany;
            this.previousCompanyName = raw.previousCompanyName;
            this.firstTimeAgonistic = raw.firstTimeAgonistic;
            this.primaryDocExpirationDate = raw.primaryDocExpirationDate;
            this.citizenshipType = raw.citizenshipType;
            this.createdAt = raw.createdAt;
            if (raw.seasons && raw.seasons.length > 0) this.seasons = raw.seasons;
            if (raw.memberships && raw.memberships.length > 0) this.memberships = raw.memberships;
            if (raw.athleteSeasons && raw.athleteSeasons.length > 0) this.athleteSeasons = raw.athleteSeasons;
            this.note = raw.note;
            if (raw.seasons && raw.seasons.length > 0) this.seasons = raw.seasons;


        }
    }
}
